import { struct } from 'io-ts/Decoder';

import { Id as JobId } from '../../../../../job/Id';
import { Id as StepId } from '../../../../../transaction/create/step/Id';

export const Params = struct({
	jobId: JobId,
	stepId: StepId,
});
